/**
 * @generated SignedSource<<e29b5259f9c1a18b3038869cbaceef99>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type DashboardPopupMenuRefactored$data = {
  readonly dashboardId: AGG$Long;
  readonly favouriteValue: {
    readonly isFavourite: boolean | null | undefined;
  } | null | undefined;
  readonly id: string;
  readonly " $fragmentType": "DashboardPopupMenuRefactored";
};
export type DashboardPopupMenuRefactored$key = {
  readonly " $data"?: DashboardPopupMenuRefactored$data;
  readonly " $fragmentSpreads": FragmentRefs<"DashboardPopupMenuRefactored">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "DashboardPopupMenuRefactored",
  "selections": [
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "id"
      },
      "action": "THROW",
      "path": "id"
    },
    {
      "kind": "RequiredField",
      "field": {
        "kind": "ScalarField",
        "name": "dashboardId"
      },
      "action": "THROW",
      "path": "dashboardId"
    },
    {
      "concreteType": "JiraFavouriteValue",
      "kind": "LinkedField",
      "name": "favouriteValue",
      "plural": false,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isFavourite"
        }
      ]
    }
  ],
  "type": "JiraDashboard"
};

(node as any).hash = "e8e3f0c665439b68ea28735cdcb03c47";

export default node;
